import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    data: null,
    status: 'idle',
    error: '',
}


export const selectedAgentSlice = createSlice({
    name: 'selectedAgent',
    initialState,
    reducers: {
        resetSelectedAgent: (state) => {
            state.data = null;
        },
        setSelectedAgent: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { resetSelectedAgent, setSelectedAgent } = selectedAgentSlice.actions;
export default selectedAgentSlice.reducer;
